import React from 'react';
import { connect } from 'react-redux';

import CommunityComponent from '../../components/app/Community/Community';

import * as actions from '../../actions/community/community';

const Community = (props) => {
  return (
    <CommunityComponent {...props} />
  );
};

export default connect(({ community, user }) => ({ communityMain: community.community, user }), actions)(Community);
